/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { BackendRoutes } from '@myprofile-ui/myprofile-localisation-api'
import { Observable, switchMap } from 'rxjs'
import { map } from 'rxjs/operators'
import { environment } from '../../../environments/environment'
import { AppConfig, AppConfigBasePartial } from './config.interface'

@Injectable({
  providedIn: 'root',
})
export class MyProfileConfigLoaderService {
  private _httpClient = inject(HttpClient)

  public getConfig(locale: string, country: string): Observable<AppConfig> {
    if (locale.length === 2) {
      locale = locale.toLowerCase() + '_' + country.toUpperCase()
    }
    let updatedLocale: string
    if (locale.includes('-')) {
      const [l1, l2] = locale.split('-')
      updatedLocale = `${l1.toLowerCase()}_${l2.toUpperCase()}`
    } else {
      const [l1, l2] = locale.split('_')
      updatedLocale = `${l1.toLowerCase()}_${l2.toUpperCase()}`
    }
    const configBasePath = BackendRoutes.CONFIG__BASE.replace(':country', country.toLowerCase())
      .replace(':locale', updatedLocale)
      .replace(':stage', environment.production ? 'p' : 'pp')
      .replace(':version', environment.production ? 'RELEASE' : 'LATEST')

    const configBaseUrl = `${environment.publicApi.localisation}/${configBasePath}`

    return this._httpClient.get<AppConfigBasePartial>(configBaseUrl).pipe(
      switchMap((configBase) =>
        this._httpClient
          .get<AppConfig>(environment.publicApi.baseUrl + `/configuration?country=${country}`, {
            headers: { 'Accept-Language': updatedLocale },
          })
          .pipe(
            map((legacyConfiguration) => ({
              // this is needed for the impersonation
              ...legacyConfiguration,
              ...configBase,
            })),
          ),
      ),
    )
  }
}
